export function serviceFormSummary() {
    let itemArray = [
        {
            key: "fields[firmanavnPrivatperson]",
            value: "firmanavnPrivatperson"
        },
        {
            key: "fields[gatenavnOgNummer]",
            value: "gatenavnOgNummer"
        },
        {
            key: "fields[postnummer]",
            value: "postnummerSted"
        },
        {
            key: "fields[kontaktpersonPaStedet]",
            value: "kontaktpersonPaStedet"
        },
        {
            key: "fields[telefon]",
            value: "telefon"
        },
        {
            key: "fields[onsketUtforelsesdato1]",
            value: "onsketUtforelsesdato1"
        },
        {
            key: "fields[orgNummer]",
            value: "orgNummer"
        },
        {
            key: "fields[firma]",
            value: "firma"
        },
        {
            key: "fields[gatenavnOgNummer1]",
            value: "gatenavnOgNummer1"
        },
        {
            key: "fields[postnummer1]",
            value: "postnummerSted1"
        },
        {
            key: "fields[navnPaBestiller]",
            value: "navnPaBestiller"
        },
        {
            key: "fields[ePost1]",
            value: "ePost1"
        },
        {
            key: "fields[telefon1]",
            value: "telefon1"
        },
        {
            key: "fields[fakturareferanse]",
            value: "fakturareferanse"
        },
        {
            key: "fields[velgServicetjeneste1][]",
            value: "velgServicetjeneste"
        },
        {
            key: "fields[typeProdukt1]",
            value: "typeProdukt"
        },
        {
            key: "fields[produktnr]",
            value: "produktnr"
        }
    ];

    document.addEventListener("DOMContentLoaded", function () {
        // let hiddenInput = document.querySelector('input[name="handle"][value="serviceskjema"]');
        let hiddenInputs = document.querySelectorAll('input[name="handle"]');

        hiddenInputs.forEach(hiddenInput => {
            if (hiddenInput.value === "serviceskjema" || hiddenInput.value === "hibasHjelpen") {
                let form = hiddenInput.closest("form");

                if (form) {
                    form.addEventListener('onAfterFormieSubmit', (e, data) => {
                        e.preventDefault();

                        if (hiddenInput.value === "serviceskjema") {
                            itemArray.forEach(item => {
                                setSummaryValue(form, item.key, item.value);
                            });
                        }

                        let nextPageIndex = e.detail.nextPageIndex;
                        if (nextPageIndex == 0) {
                            // Sidebar Code
                            document.querySelector('#sidebar-intro').classList.add('block');
                            document.querySelector('#sidebar-intro').classList.remove('hidden');
                            document.querySelector('#sidebar-tabs').classList.add('hidden');
                            document.querySelector('#sidebar-tabs').classList.remove('block');

                            // Form Title
                            document.querySelector('#formWrapperCont').classList.add('items-center', 'justify-center', 'lg:max-w-[766px]', 'w-full', 'flex', 'flex-col', 'gap-8', 'lg:min-h-full');

                            // Page Tab Title
                            let getAllTitle = document.querySelectorAll('#tabTitle');
                            if (getAllTitle) {
                                getAllTitle.forEach(item => {
                                    item.classList.add('hidden');
                                    item.classList.remove('block');
                                });
                            }
                        } else {
                            // Sidebar Code
                            document.querySelector('#sidebar-intro').classList.add('hidden');
                            document.querySelector('#sidebar-intro').classList.remove('block');
                            document.querySelector('#sidebar-tabs').classList.add('block');
                            document.querySelector('#sidebar-tabs').classList.remove('hidden');

                            // Form Title
                            document.querySelector('#formWrapperCont').classList.remove('items-center', 'justify-center', 'lg:max-w-[766px]', 'w-full', 'flex', 'flex-col', 'gap-8', 'lg:min-h-full');

                            // Page Tab Title
                            let getAllTitle = document.querySelectorAll('#tabTitle');
                            if (getAllTitle) {
                                getAllTitle.forEach(item => {
                                    item.classList.add('block');
                                    item.classList.remove('hidden');
                                });
                            }
                        }
                        // console.log(e.detail.nextPageIndex);
                        // console.log(e);
                    });
                }
            }
        });
    });

    function setSummaryValue(form, key, value) {
        let item = null;
        let output = '';
    
        if (value === "telefon" || value === "telefon1") {
            item = form.querySelector('input[name="' + key + '[number]"]');
            if (item) {
                output = item.value;
            }
        }
    
        else if (value === "onsketUtforelsesdato1") {
            item = form.querySelector('input[name="' + key + '[date]"]');
            if (item) {
                output = item.value;
            }
        }
    
        else if (value === "typeProdukt") {
            item = form.querySelector('select[name*="typeProdukt"]');
            if (item) {
                output = item.options[item.selectedIndex]?.text || '';
            }
        }

        else if (value === "produktnr") {
            item = form.querySelector('input[name*="produktnr"]');
            if (item) {
                output = item.value;
            }
        }
    
        else {
            item = form.querySelector('input[name="' + key + '"]');
            if (item) {
                output = item.value;
            }
        }
    
        if (output !== '') {
            const target = form.querySelector('#' + value);
            if (target) {
                target.textContent = output;
            }
        }
    }    
}
